(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('BrickOsfeDeleteController',BrickOsfeDeleteController);

    BrickOsfeDeleteController.$inject = ['$uibModalInstance', 'entity', 'BrickOsfe'];

    function BrickOsfeDeleteController($uibModalInstance, entity, BrickOsfe) {
        var vm = this;
        vm.brickOsfe = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            BrickOsfe.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
